import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { createAction } from 'redux-actions';
import { actionKey } from './constants';
let fileUploadIndex = 0;
const addFileId = (payload)=>_object_spread_props(_object_spread({}, payload), {
        fileId: ++fileUploadIndex
    });
export const uploadFile = createAction(`${actionKey}/UPLOAD`, (payload)=>addFileId(payload));
export const uploadFiles = createAction(`${actionKey}/UPLOAD_MULTI`, (files)=>({
        files: files.map(addFileId)
    }));
export const cancelFileUpload = createAction(`${actionKey}/UPLOAD_CANCEL`, (payload)=>payload);
export const uploadSuccess = createAction(`${actionKey}/UPLOAD/SUCCESS`, (fileId, deviationId)=>({
        fileId,
        deviationId
    }));
export const uploadFailure = createAction(`${actionKey}/UPLOAD/FAILURE`, (fileId, error)=>({
        fileId,
        error
    }));
export const uploadProgress = createAction(`${actionKey}/UPLOAD/PROGRESS`, (fileId, progress)=>({
        fileId,
        progress
    }));
export const uploadFileImmediately = createAction(`${actionKey}/UPLOAD/IMMEDIATE`, (payload)=>payload);
export const removeErroredUpload = createAction(`${actionKey}/UPLOAD/REMOVE_ENDED`, (fileId)=>({
        fileId
    }));
export const clearCompletedUploads = createAction(`${actionKey}/CLEAR_COMPLETED_UPLOADS`, ()=>({}));
export const uploadDocument = createAction(`${actionKey}/UPLOAD_DOCUMENT`, (payload)=>payload);
export const uploadDocumentProgress = createAction(`${actionKey}/UPLOAD_DOCUMENT/PROGRESS`, (documentType, progress)=>({
        documentType,
        progress
    }));
export const uploadDocumentSuccess = createAction(`${actionKey}/UPLOAD_DOCUMENT/SUCCESS`, (documentType, documentUrl)=>({
        documentType,
        documentUrl
    }));
export const uploadDocumentFailure = createAction(`${actionKey}/UPLOAD_DOCUMENT/FAILURE`, (documentType, error)=>({
        documentType,
        error
    }));
export const cancelDocumentUpload = createAction(`${actionKey}/UPLOAD_DOCUMENT/CANCEL`, (documentType)=>({
        documentType
    }));
